import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButton } from "@angular/material/button";

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    imports: [
        CommonModule,
        MatButton
    ],
    standalone: true,
})
export class BannerComponent implements OnInit {
  @Input() id: string;
  @Input() iconPath?: string = '/assets/svg/message.svg';
  @Input() iconVisible?: boolean = true;
  @Input() buttonText?: string = 'Got it';
  @Input() closeIconVisible?: boolean = true;
  @Input() closeButtonVisible?: boolean = true;
  @Input() bgColor?: string = '';
  private _storageKey: string = 'banners';
  private _bannerData: object;
  isVisible: boolean;
  constructor() {
  }

  ngOnInit(): void {
    this._bannerData = this.getBannerStorageData();
    this.isVisible = 'confirmed' in this._bannerData ? !this._bannerData['confirmed'] : true;
  }

  close(): void {
    this.storeConfirmed();
    this.isVisible = false;
  }
  private getStorageData(): object {
    const bannersDataString = localStorage.getItem(this._storageKey);
    return bannersDataString ?  JSON.parse(bannersDataString) : {};
  }

  private getBannerStorageData(): object {
    const storageData = this.getStorageData();
    return this.id in storageData ? storageData[this.id] : {};
  }

  private storeConfirmed() {
    let storageData = this.getStorageData();
    this._bannerData['confirmed'] = true
    storageData[this.id] = this._bannerData
    localStorage.setItem(this._storageKey, JSON.stringify(storageData))
  }
}
